<script>
    export let fill = '#000'
</script>

<style>
    svg#schedule-highlight-labels {
        position: absolute;
        width: 412.23px;
        height: 170.79px;
        top: 221px;
        left: 0;
    }
</style>

<svg id="schedule-highlight-labels" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 412.23 170.79">
    <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
            <rect {fill} width="412.23" height="21.77" />
            <rect {fill} x="104.21" y="149.02" width="308.02" height="21.77" />
        </g>
    </g>
</svg>
